import classNames from 'classnames';
import type { FC } from 'react';
import { colors } from 'styles/colors';

type Direction = 'right' | 'left' | 'up' | 'down';

type Props = {
  color?: string;
  className?: string;
  direction?: Direction;
};

const directionMap: Map<Direction, string> = new Map([
  ['left', 'rotate-180'],
  ['up', '-rotate-90'],
  ['down', 'rotate-90']
]);

export const ChevronIcon: FC<Props> = ({ color = colors.black, className, direction = 'right' }) => (
  <svg
    className={classNames(directionMap.get(direction), className)}
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 11.0001L6 6.00012" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M1 1L6 6" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);
